import { useForm, UseFormProps, FieldValues } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

export function useZodForm<T extends FieldValues>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  schema: any,
  options?: Omit<UseFormProps<T>, 'resolver'>
) {
  return useForm<T>({
    ...options,
    resolver: zodResolver(schema),
  });
}
